import { usePropertyIntendedWork } from '../../../queries/PropertyFields/NonRentalCoreFields';
import { MultilineTextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';
import { MultilineTextBoxLabelSize } from '@apply/components/src/components/controls/MultineTextBox';

interface IntendedWorkProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const IntendedWork: React.FC<IntendedWorkProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Briefly describe the work you intend to do';
    const [intendedWork, set_intendedWork] = usePropertyIntendedWork(propertyGuid);
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={intendedWork}
                />
            ) : (
                <MultilineTextBox
                    id='intendedWork'
                    value={intendedWork}
                    onChange={set_intendedWork}
                    label={label}
                    labelSize={MultilineTextBoxLabelSize.Small}
                    required={required}
                    validateOnFocusChange={false}
                />
            )}
        </>
    );
};
